import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import UsersAssignRoles from './UsersAssignRoles';

const UsersTab: React.FC = () => {
  return (
    <Box sx={{ px: 3 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>Użytkownicy</Typography>
      <Paper sx={{ p: 2 }}>
        <UsersAssignRoles />
      </Paper>
    </Box>
  );
};

export default UsersTab;


